import { defineComponent } from '@vue/composition-api';
import props from './description-item-props';

export default defineComponent({
  name: 'TDescriptionsItem',
  props,
});
